import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../types/form/field-format-type';
import { numberFieldValidationConfigValidator, numberFieldValidationConfigValidatorSchema } from '../../../types/form/field-validation-config';
export const defaultGiftCardPaymentFormValidationConfig = {
    cardNumber: { type: FieldFormatType.Number, minLength: 1, maxLength: 50, required: true },
    pin: { type: FieldFormatType.Number, required: true, minLength: 1, maxLength: 20 }
};
export const giftCardPaymentFormValidationConfigValidator = Validator.object({
    cardNumber: Validator.object(Object.assign(Object.assign({}, numberFieldValidationConfigValidatorSchema), { required: Validator.isEqualTo(true) })),
    pin: numberFieldValidationConfigValidator
});
